const { conditionMatchPropsData, textSort, getTempPropEnumOption } = require('../../operation');
const { getDefaultProp } = require('../../shared/prop');
const { getDefaultStatusProp } = require('../../shared/status');
const { cloneDeep, isSafeInteger } = require('lodash');
const generateId = require('../../shared/infrastructure/id-generation/generate-id');
const { DEFAULT_TEMPLATE } = require('../../constants');
// import request from '../../../../helpers/request';
// const { List, Record } = Immutable;

// const NodeEditorState = Record({
//   templateMap: null,
//   network: null,
//   orgId: '',
//   nodeId: '',
//   userId: '',
//   title: '',
//   tempId: '',
//   tempProp: [],
//   status: 0,
//   statusProp: [],
//   creator: '',
// });

const NetWorkError = Symbol('NetWorkError');
class RetryNetwork {
  constructor(network, retry = 3) {
    this._network = network;
    this._retry = retry;
  }

  async call(url, op) {
    let retry = this._retry;
    let success = false;
    let ret = NetWorkError;
    while (retry > 0) {
      try {
        ret = await this._network(url, op);
        success = true;
        break;
      } catch (e) {
        console.error(e);
      }
      retry--;
    }
    return ret;
  }
}

/**
 * @deprecated
 * 节点编辑器
 */
class NodeEditor {
  static createEmptyMini(
    _template,
    _accountId,
    _org_id,
    request,
    { userMap, onWarn = () => {}, matchInfo = null },
  ) {
    return new Promise(async (resolve) => {
      const nodeEditor = new NodeEditor({
        templateMap: _template,
        network: new RetryNetwork(request),
        userId: _accountId,
        orgId: _org_id,
        nodeId: generateId(),
        title: '',
        tempId: DEFAULT_TEMPLATE,
        tempProp: [],
        status: 0,
        statusProp: [],
        creator: _accountId,
        userMap,
        onWarn,
        matchInfo,
      });
      await nodeEditor.init();
      resolve(nodeEditor);
    });
  }
  static createEmpty(node, { userMap, onWarn = () => {}, matchInfo = null }) {
    return new Promise(async (resolve) => {
      const nodeEditor = new NodeEditor({
        templateMap: node.nodeManager._template,
        network: node.nodeManager._network,
        userId: node.nodeManager._accountId,
        orgId: node.nodeManager._org_id,
        nodeId: generateId(),
        title: '',
        tempId: DEFAULT_TEMPLATE,
        tempProp: [],
        status: 0,
        statusProp: [],
        creator: node.nodeManager._accountId,
        userMap,
        onWarn,
        matchInfo,
      });
      await nodeEditor.init();
      resolve(nodeEditor);
    });
  }
  static createWithNodeMini(
    _template,
    _accountId,
    _org_id,
    node_id,
    title,
    tempInfo,
    prop,
    request,
    { userMap, onWarn = () => {}, matchInfo = null },
  ) {
    return new Promise(async (resolve) => {
      const nodeEditor = new NodeEditor({
        templateMap: _template,
        network: new RetryNetwork(request),
        userId: _accountId,
        orgId: _org_id,
        nodeId: node_id,
        title: title,
        tempId: tempInfo.id,
        tempProp: tempInfo.prop,
        status: tempInfo.status,
        statusProp: tempInfo.statusProp,
        creator: prop._sys_creator,
        userMap,
        onWarn,
        matchInfo,
      });
      await nodeEditor.init();
      resolve(nodeEditor);
    });
  }
  static createWithNode(node, { userMap, onWarn = () => {}, matchInfo = null }) {
    return new Promise(async (resolve) => {
      const nodeEditor = new NodeEditor({
        templateMap: node.nodeManager._template,
        network: node.nodeManager._network,
        userId: node.nodeManager._accountId,
        orgId: node.nodeManager._org_id,
        nodeId: node.node_id,
        title: node.title,
        tempId: node.tempInfo.id,
        tempProp: node.tempInfo.prop,
        status: node.tempInfo.status,
        statusProp: node.tempInfo.statusProp,
        creator: node.prop._sys_creator,
        createTime: node.prop._sys_createTime,
        userMap,
        onWarn,
        matchInfo,
      });
      await nodeEditor.init();
      resolve(nodeEditor);
    });
  }

  constructor({
    templateMap,
    network,
    orgId,
    nodeId,
    userId,
    title = '',
    tempId,
    tempProp,
    status,
    statusProp,
    creator,
    createTime,
    userMap,
    onWarn,
    matchInfo,
  }) {
    this.templateMap = templateMap;
    this.network = network;
    this.orgId = orgId;
    this.nodeId = nodeId;
    this.userId = userId;
    this.title = title;
    this.tempId = tempId;
    this.tempProp = tempProp;
    this.status = status;
    this.statusProp = statusProp;
    this.creator = creator;
    this.createTime = createTime;
    this.userMap = userMap;
    this.onWarn = onWarn;
    if (matchInfo) {
      this.tempMatchInfo = matchInfo;
    }
  }

  getTempConfig() {
    return this.templateMap[this.tempId];
  }
  getTempPropConfig() {
    const tempConfig = this.getTempConfig();
    if (!tempConfig) {
      return [];
    }
    return tempConfig.prop || [];
  }
  getStatusConfig() {
    const tempConfig = this.getTempConfig();
    if (!tempConfig) {
      return [];
    }
    return tempConfig.task_status || [];
  }
  getStatusPropConfig() {
    const statusConfig = this.getStatusConfig();
    if (!statusConfig || !statusConfig[this.status]) {
      return [];
    }
    return statusConfig[this.status].prop || [];
  }

  /**
   * 初始化
   * 1. 更新 模板匹配信息
   * 2. 更新 选值选项
   */
  async init() {
    if (!this.tempMatchInfo) {
      await this.updateTempMatchInfo();
    }
    this.updateOptions();
  }

  /**
   * TODO 修改标题
   */
  setTitle(text) {
    // 处理标题匹配
  }

  /**
   * TODO 标题匹配
   */
  matchTitle() {}
  /**
   * 设置模板
   * 1. 更新 模板id
   * 2. 更新 模板匹配信息
   * 3. 更新 选值选项
   * 4. 更新 模板属性
   * 5. 更新 默认状态
   * 6. 更新 默认状态属性
   */
  async setTempId(tempId) {
    this.tempId = tempId;

    await this.updateTempMatchInfo();
    this.tempProp = getDefaultProp(
      this.getTempConfig(),
      this.tempMatchInfo,
      this.userMap,
      this.userId,
      this.userId,
      Date.now(),
    );
    this.status = 0;
    this.statusProp = getDefaultStatusProp(
      { tempProp: this.tempProp, creator: this.userId, createTime: Date.now() },
      this.status,
      this.getTempConfig(),
      this.userId,
      [],
      false,
      false,
    );

    this.updateOptions();
  }
  /**
   * 设置模板属性
   * 1. 更新 模板属性
   * 2. 条件匹配
   * 3. 更新 选值
   */
  // TODO 更新 引用模板属性的状态属性
  /**
   * FIXME: 小程序三合一表单-状态切换-状态表单-关联属性更新
   * 不应该给状态属性添加默认值, 暂时通过 skipStatus 跳过该逻辑
   */
  setTempPropByIndex(index, value, skipStatus = false) {
    index = Number(index);
    const newProp = cloneDeep(this.tempProp);
    newProp[index] = value;
    const [matchData, _] = conditionMatchPropsData({
      handleDataIndex: index,
      propData: newProp,
      userMap: this.userMap,
      template: this.getTempConfig(),
      matchConfig: this.tempMatchInfo,
      creator: this.creator,
      changedFields: [index],
      createTime: this.createTime,
      currentUserId: this.userId,
    });
    this.tempProp = matchData;
    if (!skipStatus) {
      this.setStatus(this.status); //更新模板属性值   对应的状态引用属性可能随之改变
    }
    this.updateOptions();
  }

  /**
   * 更新状态的属性值
   *
   */
  updateStatusProps() {
    const task_status = this.templateMap?.[this.tempId]?.['task_status'];
    const curStatus = task_status.find((x) => x.index === this.status) || null;
    if (curStatus && curStatus.prop) {
      const oldStatusProp = [...this.statusProp];
      curStatus.prop.forEach((x, i) => {
        const reg = /^prop[0-9]{1,2}$/g;
        if (reg.test(x.defaultValue)) {
          const tempIndex = x.defaultValue.match(/\d+/g);
          oldStatusProp[i] = this.tempProp[tempIndex];
        }
      });
      this.statusProp = oldStatusProp;
    }
  }

  /**
   * 设置状态
   * 1. 更新状态
   * 2. 更新状态属性
   */
  // TODO 处理没有默认值的必填项
  setStatus(index) {
    this.status = index;
    this.statusProp = getDefaultStatusProp(
      { tempProp: this.tempProp, creator: this.userId, createTime: Date.now() },
      this.status,
      this.getTempConfig(),
      this.userId,
      undefined,
      false,
      false,
    );
  }
  /**
   * 设置状态属性
   * 1. 更新 状态属性
   * 2. 开始时间和结束时间限制
   */
  setTempStatusPropByIndex(index, value) {
    index = Number(index);
    const newStatusProp = cloneDeep(this.statusProp);
    newStatusProp[index] = value;
    this.statusProp = newStatusProp;
  }
  /**
   * 更新匹配数据
   */
  async updateTempMatchInfo() {
    if (this.tempId === DEFAULT_TEMPLATE) {
      this.tempMatchInfo = [];
      return;
    }
    const res = await this.network.call('/docapi/getMatchProps', {
      method: 'POST',
      data: {
        org_id: this.orgId,
        temp_id: this.tempId,
      },
    });
    if (res.status !== 'ok') {
      this.tempMatchInfo = [];
    } else {
      this.tempMatchInfo = res.data || [];
    }
  }
  /**
   * 设置 属性值
   */
  setTempProp({ newData }) {
    this.tempProp = newData;
    this.updateOptions();
  }

  /**
   * 更新 选值
   */
  updateOptions() {
    const temp = this.templateMap[this.tempId];
    if (temp && temp.prop && temp.prop.length) {
      this.tempPropOptions = temp.prop.map((prop, index) => {
        if (!prop || !Object.keys(prop).length) {
          return null;
        }
        if (!prop.conditionMatching && !prop.enumQuote) {
          return null;
        }

        const options = getTempPropEnumOption({
          propData: this.tempProp,
          dataIndex: index,
          dataType: prop.type,
          matchConfig: this.tempMatchInfo,
          creator: this.userId,
          title: this.title,
        });
        return options || null;
      });
    } else {
      this.tempPropOptions = [];
    }
  }
}

module.exports = NodeEditor;
